import React from "react";
import { Button } from "flowbite-react";
import {
  HiOutlineTag,
  HiOutlineDownload,
  HiOutlineShare,
  HiOutlineCalendar,
  HiOutlineTrash,
  HiX,
} from "react-icons/hi";
import { exportTransactionsToCSV } from "../utils/exportUtils";
import { Transaction } from "../../../domain/types/Transaction";

interface BulkActionsProps {
  selectedCount: number;
  selectedTransactions: Transaction[];
  onClearSelection: () => void;
}

export const BulkActions: React.FC<BulkActionsProps> = ({
  selectedCount,
  selectedTransactions,
  onClearSelection,
}) => {
  const handleExport = async () => {
    await exportTransactionsToCSV(selectedTransactions);
  };

  const handleBulkCategorize = () => {
    // Open category selection modal
  };

  const handleBulkShare = () => {
    // Open share with family members modal
  };

  const handleBulkCalendar = () => {
    // Open calendar event creation modal
  };

  const handleBulkDelete = () => {
    // Open delete confirmation modal
  };

  return (
    <div className="bg-indigo-50 dark:bg-indigo-900/20 p-4 border-b border-indigo-100 dark:border-indigo-800">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <span className="text-indigo-700 dark:text-indigo-300 font-medium">
            {selectedCount}{" "}
            {selectedCount === 1 ? "transaction" : "transactions"} selected
          </span>
          <button
            onClick={onClearSelection}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          >
            <HiX className="w-5 h-5" />
          </button>
        </div>

        <div className="flex items-center space-x-2">
          <Button size="sm" color="light" onClick={handleBulkCategorize}>
            <HiOutlineTag className="w-4 h-4 mr-2" />
            Categorize
          </Button>

          <Button size="sm" color="light" onClick={handleExport}>
            <HiOutlineDownload className="w-4 h-4 mr-2" />
            Export
          </Button>

          <Button size="sm" color="light" onClick={handleBulkShare}>
            <HiOutlineShare className="w-4 h-4 mr-2" />
            Share
          </Button>

          <Button size="sm" color="light" onClick={handleBulkCalendar}>
            <HiOutlineCalendar className="w-4 h-4 mr-2" />
            Calendar
          </Button>

          <Button size="sm" color="failure" onClick={handleBulkDelete}>
            <HiOutlineTrash className="w-4 h-4 mr-2" />
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};
